"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupplementalDataUsage = exports.usageValues = void 0;
/**
 * Allowed usages according to valueSet https://terminology.hl7.org/3.1.0/ValueSet-measure-data-usage.html.
 * Using typeof with allowed usages lets us both define a type (using SupplementalDataUsage) and determine
 * whether a value is validly typed (using usageValues const).
 */
exports.usageValues = ['supplemental-data', 'risk-adjustment-factor'];
function isSupplementalDataUsage(u) {
    return exports.usageValues.includes(u);
}
exports.isSupplementalDataUsage = isSupplementalDataUsage;
//# sourceMappingURL=Calculator.js.map